import h from 'react-hyperscript';

import './Services.css';

import Section from '../../Section';

const Rows = [
  {
    title: 'Event Coordination',
    desc: "We provide a best in class tool for coordinating your venue's events.",
    iconClass: '.fa.fa-bullhorn',
  },
  {
    title: 'Easy Event Prep',
    desc: 'Quickly create and prepare for events weeks in advance.',
    iconClass: '.fa.fa-calendar-check-o',
  },
  {
    title: 'Real-time Analytics',
    desc: 'Event coordinators can check fullfillment status as it happens on any device.',
    iconClass: '.fa.fa-bar-chart',
  },
  {
    title: 'On-the-fly Adjustments',
    desc: 'Make adjustments as far in advance as you like or while your event is ramping up',
    iconClass: '.fa.fa-random',
  },
].map(row => {
  const { title, desc, iconClass } = row;

  return h('.service-list', [
    h('.service-list-col1.wow.fadeInRight.delay-02s', [h(`i${iconClass}`)]),
    h('.service-list-col2.wow.fadeInRight.delay-02s', [h('h3', title), h('p', desc)]),
  ]);
});

const Services = () =>
  h(Section, { id: 'service' }, [
    h('h2', 'Services'),
    h('h6', 'We offer exceptional services with complimentary hugs.'),
    h('.row', [
      h('.col-lg-4.col-sm-6.wow.fadeInLeft.delay-05s', Rows),
      h('figure.col-lg-8.col-sm-6.text-right.wow.fadeInUp.delay-02s', [
        h('img', {
          style: { maxWidth: '100%', height: '390px' },
          src: 'img/logo-npo-light-circle.png',
          alt: 'Laptop',
        }),
      ]),
    ]),
  ]);

export default Services;

// <section class="main-section" id="service"><!--main-section-start-->
//   <div class="container">
//     <h2>Services</h2>
//     <h6>We offer exceptional service with complimentary hugs.</h6>
//     <div class="row">
//       <div class="col-lg-4 col-sm-6 wow fadeInLeft delay-05s">
//         <div class="service-list">
//           <div class="service-list-col1">
//             <i class="fa-paw"></i>
//           </div>
//           <div class="service-list-col2">
//             <h3>branding &amp; identity</h3>
//             <p>Proin iaculis purus digni consequat sem digni ssim. Donec entum digni ssim.</p>
//           </div>
//         </div>
//         <div class="service-list">
//           <div class="service-list-col1">
//             <i class="fa-gear"></i>
//           </div>
//           <div class="service-list-col2">
//             <h3>web development</h3>
//             <p>Proin iaculis purus consequat sem digni ssim. Digni ssim porttitora .</p>
//           </div>
//         </div>
//         <div class="service-list">
//           <div class="service-list-col1">
//             <i class="fa-apple"></i>
//           </div>
//           <div class="service-list-col2">
//             <h3>mobile design</h3>
//             <p>Proin iaculis purus consequat digni sem digni ssim. Purus donec porttitora entum.</p>
//           </div>
//         </div>
//         <div class="service-list">
//           <div class="service-list-col1">
//             <i class="fa-medkit"></i>
//           </div>
//           <div class="service-list-col2">
//             <h3>24/7 Support</h3>
//             <p>Proin iaculis purus consequat sem digni ssim. Sem porttitora entum.</p>
//           </div>
//         </div>
//       </div>
//       <figure class="col-lg-8 col-sm-6  text-right wow fadeInUp delay-02s">
//         <img src="img/macbook-pro.png" alt="">
//       </figure>
//
//     </div>
//   </div>
// </section><!--main-section-end-->



// WEBPACK FOOTER //
// ./src/components/Sections/Services/Services.js